enum PatientOriginFilter {
    D = 1,
    E = 2,
    I = 3,
    O = 4,
}

export default PatientOriginFilter;
